<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hefr.hefr_oms}} from the accommodation {{hefr.hefc_nr}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHefr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hefr_encrid: null,
      hefr: {}
    }
  },
  methods: {
    open(hefr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/hefr/getHefr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHefr"
          },
          getHefr: {
            hefr_encrid: hefr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefr = res.data.getHefr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHefr() { 
      this.$axios
        .post("ares/json/ares/eign/hefc/hefr/rmHefr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHefr"
          },
          rmHefr: {
            hefr_encrid: this.hefr.hefr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             if (res.data.rmHefr.color == "success") { 
                setTimeout(() => { this.$router.reload('/eign/hefc/onHefcTmp/' + res.data.rmHefr.hefc_encrid);  }, 2000);      
             }   
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHefr.text,
              color: res.data.rmHefr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

